import AnchorCheckbox from './AnchorCheckbox';
import PropTypes from 'prop-types';

const AnchorCheckboxList = (props) => {

    const {
        userData,
        value
    } = props;

    return (
        userData[value]?.map(item => {
            const newProps = {
                ...props,
                ...item
            }
            return (
                <>
                    <AnchorCheckbox {...newProps} />
                    <span class="space space--3rows"></span>
                </>
            )
        })
    )
}

export default AnchorCheckboxList;

AnchorCheckboxList.defaultProps = {
    value: ""
};

AnchorCheckboxList.propTypes = {
    value: PropTypes.string,
    userData: PropTypes.object.isRequired
};